/** AUTO-GENERATED - DO NOT EDIT **/

export type Color =
  | 'black'
  | 'blue-100'
  | 'blue-200'
  | 'blue-300'
  | 'blue-400'
  | 'blue-50'
  | 'blue-500'
  | 'blue-600'
  | 'blue-700'
  | 'blue-800'
  | 'blue-900'
  | 'blue-950'
  | 'brand-yellow-loud'
  | 'brand-yellow-loud-hover'
  | 'brand-yellow-soft'
  | 'brand-yellow-soft-hover'
  | 'gray-100'
  | 'gray-200'
  | 'gray-300'
  | 'gray-400'
  | 'gray-50'
  | 'gray-500'
  | 'gray-600'
  | 'gray-700'
  | 'gray-800'
  | 'gray-900'
  | 'gray-950'
  | 'green-100'
  | 'green-200'
  | 'green-300'
  | 'green-400'
  | 'green-50'
  | 'green-500'
  | 'green-600'
  | 'green-700'
  | 'green-800'
  | 'green-900'
  | 'green-950'
  | 'lilac-100'
  | 'lilac-200'
  | 'lilac-300'
  | 'lilac-400'
  | 'lilac-50'
  | 'lilac-500'
  | 'lilac-600'
  | 'lilac-700'
  | 'lilac-800'
  | 'lilac-900'
  | 'lilac-950'
  | 'orange-100'
  | 'orange-200'
  | 'orange-300'
  | 'orange-400'
  | 'orange-50'
  | 'orange-500'
  | 'orange-600'
  | 'orange-700'
  | 'orange-800'
  | 'orange-900'
  | 'orange-950'
  | 'pink-100'
  | 'pink-200'
  | 'pink-300'
  | 'pink-400'
  | 'pink-50'
  | 'pink-500'
  | 'pink-600'
  | 'pink-700'
  | 'pink-800'
  | 'pink-900'
  | 'pink-950'
  | 'purple-100'
  | 'purple-200'
  | 'purple-300'
  | 'purple-400'
  | 'purple-50'
  | 'purple-500'
  | 'purple-600'
  | 'purple-700'
  | 'purple-800'
  | 'purple-900'
  | 'purple-950'
  | 'red-100'
  | 'red-200'
  | 'red-300'
  | 'red-400'
  | 'red-50'
  | 'red-500'
  | 'red-600'
  | 'red-700'
  | 'red-800'
  | 'red-900'
  | 'red-950'
  | 'teal-100'
  | 'teal-200'
  | 'teal-300'
  | 'teal-400'
  | 'teal-50'
  | 'teal-500'
  | 'teal-600'
  | 'teal-700'
  | 'teal-800'
  | 'teal-900'
  | 'teal-950'
  | 'white'
  | 'yellow-100'
  | 'yellow-200'
  | 'yellow-300'
  | 'yellow-400'
  | 'yellow-50'
  | 'yellow-500'
  | 'yellow-600'
  | 'yellow-700'
  | 'yellow-800'
  | 'yellow-900'
  | 'yellow-950';
export type Space = '2xl' | '3xl' | '4xl' | '5xl' | 'lg' | 'md' | 'sm' | 'xl' | 'xs';
export type FontFamily = 'decorative' | 'monospace' | 'primary';
export type FontSize = '2xl' | '3xl' | 'lg' | 'md' | 'sm' | 'xl' | 'xs';
export type LineHeight = '2xl' | '2xs' | '3xl' | '3xs' | 'lg' | 'md' | 'none' | 'sm' | 'xl' | 'xs';
export type FontWeight = 'bold' | 'medium' | 'regular' | 'semibold';
export type BorderRadius = '2xl' | 'full' | 'lg' | 'md' | 'sm' | 'xl' | 'xs';
export type Breakpoint = '2xl' | 'lg' | 'md' | 'sm' | 'xl' | 'xs';
export type Valence =
  | 'negative-bg'
  | 'negative-border'
  | 'negative-fg'
  | 'negative-strong'
  | 'neutral-bg'
  | 'neutral-border'
  | 'neutral-fg'
  | 'neutral-strong'
  | 'positive-bg'
  | 'positive-border'
  | 'positive-fg'
  | 'positive-strong';
export type FocusRing = 'color' | 'offset' | 'width';

export const theme = {
  color: {
    black: 'oklch(0 0 0)',
    'blue-50': 'oklch(0.9705 0.0143 254.66)',
    'blue-100': 'oklch(0.9319 0.0317 255.61)',
    'blue-200': 'oklch(0.8827 0.0583 254.83)',
    'blue-300': 'oklch(0.8092 0.1 249.59)',
    'blue-400': 'oklch(0.7036 0.1587 253.42)',
    'blue-500': 'oklch(0.6189 0.2066 259.36)',
    'blue-600': 'oklch(0.5457 0.2443 262.91)',
    'blue-700': 'oklch(0.4878 0.2433 264.41)',
    'blue-800': 'oklch(0.4242 0.1983 265.5)',
    'blue-900': 'oklch(0.3796 0.1453 265.47)',
    'blue-950': 'oklch(0.2802 0.0909 268.05)',
    'gray-50': 'oklch(0.9846 0.0018 248.57)',
    'gray-100': 'oklch(0.967 0.003 264.51)',
    'gray-200': 'oklch(0.9276 0.0059 264.52)',
    'gray-300': 'oklch(0.872 0.0106 261.8)',
    'gray-400': 'oklch(0.7075 0.0206 262.98)',
    'gray-500': 'oklch(0.5502 0.0273 262.02)',
    'gray-600': 'oklch(0.4461 0.0299 257.69)',
    'gray-700': 'oklch(0.3731 0.0343 260.18)',
    'gray-800': 'oklch(0.2778 0.0319 256.29)',
    'gray-900': 'oklch(0.2099 0.0342 263.44)',
    'gray-950': 'oklch(0.1296 0.0274 261.7)',
    'green-50': 'oklch(0.9819 0.018 156.09)',
    'green-100': 'oklch(0.9624 0.0434 156.85)',
    'green-200': 'oklch(0.925 0.0805 156.05)',
    'green-300': 'oklch(0.8712 0.1363 154.48)',
    'green-400': 'oklch(0.8003 0.182 151.73)',
    'green-500': 'oklch(0.7227 0.192 149.6)',
    'green-600': 'oklch(0.627 0.1699 149.23)',
    'green-700': 'oklch(0.5273 0.1371 150.09)',
    'green-800': 'oklch(0.4479 0.1083 151.35)',
    'green-900': 'oklch(0.3925 0.0896 152.56)',
    'green-950': 'oklch(0.2664 0.0628 152.96)',
    'lilac-50': 'oklch(0.958 0.0203 279.87)',
    'lilac-100': 'oklch(0.9299 0.0335 272.77)',
    'lilac-200': 'oklch(0.8526 0.0751 283.01)',
    'lilac-300': 'oklch(0.7522 0.1312 282.78)',
    'lilac-400': 'oklch(0.6564 0.1886 282.28)',
    'lilac-500': 'oklch(0.5896 0.2288 279.82)',
    'lilac-600': 'oklch(0.5101 0.2619 276.94)',
    'lilac-700': 'oklch(0.4562 0.2397 276.94)',
    'lilac-800': 'oklch(0.402 0.1947 280)',
    'lilac-900': 'oklch(0.3673 0.142 284.7)',
    'lilac-950': 'oklch(0.262 0.0901 286.51)',
    'orange-50': 'oklch(0.9796 0.0157 73.64)',
    'orange-100': 'oklch(0.9542 0.0371 75.15)',
    'orange-200': 'oklch(0.9015 0.0729 70.69)',
    'orange-300': 'oklch(0.8366 0.1165 66.28)',
    'orange-400': 'oklch(0.7577 0.159 55.93)',
    'orange-500': 'oklch(0.7049 0.1867 47.6)',
    'orange-600': 'oklch(0.6461 0.1943 41.11)',
    'orange-700': 'oklch(0.5534 0.1738 38.39)',
    'orange-800': 'oklch(0.4698 0.143 37.29)',
    'orange-900': 'oklch(0.4084 0.1164 38.16)',
    'orange-950': 'oklch(0.2659 0.0762 36.25)',
    'pink-50': 'oklch(0.9714 0.0142 342.87)',
    'pink-100': 'oklch(0.9482 0.0277 342.09)',
    'pink-200': 'oklch(0.8994 0.0589 343.16)',
    'pink-300': 'oklch(0.8228 0.1095 345.98)',
    'pink-400': 'oklch(0.7253 0.1752 349.74)',
    'pink-500': 'oklch(0.6559 0.2118 354.3)',
    'pink-600': 'oklch(0.5917 0.218 0.57)',
    'pink-700': 'oklch(0.5246 0.1989 3.95)',
    'pink-800': 'oklch(0.4587 0.1697 3.81)',
    'pink-900': 'oklch(0.4078 0.1442 2.42)',
    'pink-950': 'oklch(0.2845 0.1048 3.9)',
    'purple-50': 'oklch(0.9658 0.0148 294.31)',
    'purple-100': 'oklch(0.9433 0.0285 294.51)',
    'purple-200': 'oklch(0.8946 0.0563 293.02)',
    'purple-300': 'oklch(0.8101 0.1056 293.68)',
    'purple-400': 'oklch(0.6989 0.176 294.11)',
    'purple-500': 'oklch(0.6005 0.2425 293.89)',
    'purple-600': 'oklch(0.5404 0.2811 292.85)',
    'purple-700': 'oklch(0.4907 0.27 292.57)',
    'purple-800': 'oklch(0.4316 0.232 292.71)',
    'purple-900': 'oklch(0.3801 0.1889 293.64)',
    'purple-950': 'oklch(0.284 0.1415 291.29)',
    'red-50': 'oklch(0.9705 0.0129 17.04)',
    'red-100': 'oklch(0.9356 0.0309 17.58)',
    'red-200': 'oklch(0.8845 0.0592 18.27)',
    'red-300': 'oklch(0.8077 0.1035 19.54)',
    'red-400': 'oklch(0.7106 0.1661 22.2)',
    'red-500': 'oklch(0.6369 0.2078 25.32)',
    'red-600': 'oklch(0.5771 0.2151 27.32)',
    'red-700': 'oklch(0.5054 0.1905 27.51)',
    'red-800': 'oklch(0.4437 0.1613 26.89)',
    'red-900': 'oklch(0.3959 0.1331 25.71)',
    'red-950': 'oklch(0.2575 0.0885 26.03)',
    'teal-50': 'oklch(0.9836 0.0142 181.06)',
    'teal-100': 'oklch(0.9526 0.0498 180.9)',
    'teal-200': 'oklch(0.9099 0.0927 180.48)',
    'teal-300': 'oklch(0.8549 0.1251 181.11)',
    'teal-400': 'oklch(0.7845 0.1325 181.94)',
    'teal-500': 'oklch(0.7037 0.123 182.53)',
    'teal-600': 'oklch(0.6002 0.1039 184.73)',
    'teal-700': 'oklch(0.5109 0.0861 186.42)',
    'teal-800': 'oklch(0.437 0.0705 188.25)',
    'teal-900': 'oklch(0.3861 0.059 188.45)',
    'teal-950': 'oklch(0.2773 0.0447 192.56)',
    white: 'oklch(1 0.0001 263.28)',
    'yellow-50': 'oklch(0.9873 0.0262 102.28)',
    'yellow-100': 'oklch(0.9727 0.0705 103.32)',
    'yellow-200': 'oklch(0.9466 0.1292 102.4)',
    'yellow-300': 'oklch(0.9052 0.1823 98.7)',
    'yellow-400': 'oklch(0.8545 0.1746 88.39)',
    'yellow-500': 'oklch(0.7958 0.1638 82.17)',
    'yellow-600': 'oklch(0.6834 0.1471 71.05)',
    'yellow-700': 'oklch(0.5566 0.1266 63.25)',
    'yellow-800': 'oklch(0.4761 0.1106 60.93)',
    'yellow-900': 'oklch(0.4197 0.0957 56.9)',
    'yellow-950': 'oklch(0.353 0.0823 52.45)',
    'brand-yellow-loud': '#e0ff33',
    'brand-yellow-loud-hover': '#d3f000',
    'brand-yellow-soft': '#e5ff66',
    'brand-yellow-soft-hover': 'var(--color__brand-yellow-loud)',
  },
  space: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    '2xl': '2rem',
    '3xl': '2.5rem',
    '4xl': '3rem',
    '5xl': '4rem',
  },
  fontFamily: {
    primary: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    decorative: "'Proto Grotesk', sans-serif",
    monospace: 'SFMono-Regular, Menlo, monospace',
  },
  fontSize: {
    xs: '0.625rem',
    sm: '0.75rem',
    md: '0.875rem',
    lg: '1rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
  },
  lineHeight: {
    none: '1',
    '3xs': '0.75rem',
    '2xs': '0.875rem',
    xs: '1.125rem',
    sm: '1.25rem',
    md: '1.375rem',
    lg: '1.5rem',
    xl: '1.75rem',
    '2xl': '2rem',
    '3xl': '2.25rem',
  },
  fontWeight: { regular: '400', medium: '500', semibold: '600', bold: '700' },
  borderRadius: {
    xs: '0.1875rem',
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    full: '9999rem',
  },
  breakpoint: {
    xs: '20rem',
    sm: '34rem',
    md: '48rem',
    lg: '63.25rem',
    xl: '80rem',
    '2xl': '87.5rem',
  },
  valence: {
    'positive-fg': 'var(--color__teal-700)',
    'positive-bg': 'var(--color__teal-50)',
    'positive-border': 'var(--color__teal-200)',
    'positive-strong': 'var(--color__teal-600)',
    'negative-fg': 'var(--color__purple-900)',
    'negative-bg': 'var(--color__purple-50)',
    'negative-border': 'var(--color__purple-200)',
    'negative-strong': 'var(--color__purple-600)',
    'neutral-fg': 'var(--color__gray-700)',
    'neutral-bg': 'var(--color__gray-50)',
    'neutral-border': 'var(--color__gray-200)',
    'neutral-strong': 'var(--color__gray-900)',
  },
  focusRing: { color: 'var(--color__lilac-500)', width: '2px', offset: '2px' },
} as const;

export type Theme = typeof theme;
